import React from 'react';
import styled from "styled-components";

import TimeSwitcher from "./TimeSwitcher";
import UserAvatar from "./UserAvatar";

function Sidebar(props) {
    return (
        <Item>
            <UserInfo>
                <div>
                    <UserAvatar></UserAvatar>
                </div>
                <div>
                    Report for
                </div>
                <ProfileName>
                    John Doe
                </ProfileName>
            </UserInfo>
            <SwitcherWrapper>
                <TimeSwitcher onViewUpdate={props.onViewUpdate}></TimeSwitcher>
            </SwitcherWrapper>
        </Item>
    );
}

const Item = styled.div`
  background-color: var(--dark-blue);
  color: white;
  border-radius: var(--border-radius-base);
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
`

const UserInfo = styled.div`
  background-color: var(--primary-blue);
  color: white;
  padding: var(--default-padding);
  padding-bottom: calc(var(--default-padding) * 2);
  border-radius: var(--border-radius-base);
  position: relative;
  display: flex;
  flex-direction: column;
`

const ProfileName = styled.div`
  font-size: 2.5rem;
  font-weight: 400;
`

const SwitcherWrapper = styled.div`
  padding: var(--default-padding)
`


export default Sidebar;